import { render, staticRenderFns } from "./PdvDesktopLayout.vue?vue&type=template&id=4e29dfae&scoped=true"
import script from "./PdvDesktopLayout.vue?vue&type=script&lang=js"
export * from "./PdvDesktopLayout.vue?vue&type=script&lang=js"
import style0 from "./PdvDesktopLayout.vue?vue&type=style&index=0&id=4e29dfae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e29dfae",
  null
  
)

export default component.exports